export default __webpack_public_path__ + "static/media/WM0480.34I-43863_-26179_0.6c08669e.jpg";